import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { NotFoundComponent } from './views/notfound/notfound.component';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: 'recover',
        loadComponent: () => import('./views/standalone/recover/recover.component').then(m => m.RecoverComponent)
    },
    {
        path: 'new-password',
        loadComponent: () => import('./views/standalone/new-password/new-password.component').then(m => m.NewPasswordComponent)
    },
    {
        path: 'credentials',
        loadComponent: () => import('./views/standalone/credentials/credentials.component').then(m => m.CredentialsComponent)
    },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: '', loadChildren: () => import('src/app/views/main/main.module').then(m => m.MainModule) },
    { path: '**', component: NotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
